import { useEffect, useRef } from 'react';

/**
 * Hace logout automático tras X minutos de inactividad si el flag está activo.
 *
 * Activación de eventos: mousedown, keydown, touchstart, scroll. Cualquiera
 * resetea el contador. La pestaña en background no produce eventos → el
 * timer expira y se desloguea aunque el usuario no esté tocando, pero esto
 * es deseable según el flag (cumplimiento RD/GDPR).
 *
 * @param {boolean} enabled
 * @param {() => void} onLogout
 * @param {number} minutes default 30
 */
export function useIdleLogout(enabled, onLogout, minutes = 30) {
  const timerRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    const reset = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        // Pequeño aviso vía console + ejecutar logout
        try { console.info('[idle-logout] sesión cerrada por inactividad'); } catch (_) {}
        onLogout();
      }, minutes * 60 * 1000);
    };

    const events = ['mousedown', 'keydown', 'touchstart', 'scroll'];
    events.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      events.forEach(e => window.removeEventListener(e, reset));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [enabled, onLogout, minutes]);
}
